import React from "react"
import { Main, ArticleContainer } from "../../styles/Container"
import { Heading2 } from "../../styles/Heading"
import Button from "@material-ui/core/Button"

import styled from "@emotion/styled"
import Spinner from "@nvdb-rapport/shared/src/components/Spinner"

import { downloadContractLink } from "../../data/api"

import Head from "@nvdb-rapport/shared/src/components/Head"

import { ReportModel, ReportAction } from "../../update/report"
import { UIAction } from "../../update/ui"

import { SuccessPoll } from "@nvdb-rapport/shared/src/ApiData"
import { GeneriskModel, GeneriskAction } from "./update"

interface DataReadyProps {
  reportState: ReportModel;
  reportDispatch: React.Dispatch<ReportAction>;
  uiDispatch: React.Dispatch<UIAction>;
  generiskState: GeneriskModel;
  generiskDispatch: React.Dispatch<GeneriskAction>;
}

export default function DataReady({
  reportState,
  generiskDispatch,
  generiskState,
  uiDispatch,
  reportDispatch,
}: DataReadyProps) {
  const tableheaderRef = React.useRef<HTMLHeadingElement | null>(null)
  React.useEffect(() => {
    console.log(tableheaderRef)
    console.log("offsetTop", tableheaderRef?.current?.offsetTop)

    setTimeout(() => {
      console.log("Trying to scroll")
      window.scrollTo({
        behavior: "smooth",
        top: tableheaderRef.current ? tableheaderRef.current.offsetTop : 1500,
      })
    }, 500)
  }, [])
  return reportState.contract.caseOf({
    Just: contract => {
      const fetchedContract = contract as SuccessPoll
      return (
        <>
          <Head
            title={generiskState.selectedContractArea.caseOf({
              Just: area => area.navn,
              Nothing: () => "Innhentet Rapport",
            })}
            siteTitle="Vegnett og objektdata for driftskontrakter"
            status="green"
          />
          <Main>
            <ArticleContainer>
              <Heading2>Rapporten er klart til nedlasting</Heading2>
              <StyledContentContainer>
                <StyledButtonsContainer>
                  <Button
                    color="primary"
                    variant="contained"
                    style={{ marginBottom: "2rem" }}
                    href={`${downloadContractLink(
                      fetchedContract.rapport.nedlastLink,
                      fetchedContract.rapport.filtype
                    )}`}
                  >
                    Last ned regneark ({`.${fetchedContract.rapport.filtype}`})
                  </Button>
                  {/*<Button*/}
                    {/*color="secondary"*/}
                    {/*variant="contained"*/}
                    {/*onClick={() => {*/}
                      {/*generiskDispatch({ type: "Reset" })*/}
                      {/*reportDispatch({ type: "Reset" })*/}
                      {/*uiDispatch({*/}
                        {/*type: "UpdateAppState",*/}
                        {/*payload: AppState.APP_READY,*/}
                      {/*})*/}
                    {/*}}*/}
                  {/*>*/}
                    {/*Nytt søk*/}
                  {/*</Button>*/}
                </StyledButtonsContainer>
              </StyledContentContainer>
            </ArticleContainer>
          </Main>
        </>
      )
    },
    Nothing: () => {
      return <Spinner></Spinner>
    },
  })
}

const StyledContentContainer = styled.div`
  font-size: 1.5rem;
  border: 0.1rem solid #333;
  padding: 2rem;
`

const StyledButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
`
